module.exports = __webpack_public_path__ + "static/media/billing.a0849ff0.svg";